import { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import HeroSection from "../Components/HeroSection";
import { Serviceslist } from "../Components/ServicesContainer";
import BackgroundGradient from "../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../Images/BackgroundGradientSmall.png";
import { currentSite } from "../Config/siteConfig";
export default function Services() {
  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    updateBackgroundImage();
    window.addEventListener("resize", updateBackgroundImage);
    return () => window.removeEventListener("resize", updateBackgroundImage);
  }, []);
  return (
    <div className=" w-full h-full flex flex-col ">
      {/* Header */}
      <Header id={4} />

      {/* Main Content (takes remaining space) */}
      <div
        className="flex-1 bg-primary7  w-full flex flex-col items-center justify-start bg-contain bg-repeat "
        style={{ backgroundImage: backgroundImage }}
      >
        <div className="w-full bg-primary7 flex flex-col items-center justify-center">
          <div className="w-full h-[25rem]">
            <HeroSection
              title1="Unmatched Services"
              title2="Unmatched Excellence"
              content={`At ${
                currentSite === "site1" ? "Qulabs" : "Quantum AI Global"
              }, Discover our end-to-end quantum and AI services, designed to help organizations adopt, integrate, and scale next-generation technologies from system deployment to advanced solution development. `}
            />
          </div>

          <div className="w-full bg-primary7 width md:px-10 flex flex-col items-center justify-center gap-2">
            <Serviceslist />
          </div>
        </div>
      </div>

      {/* Footer (always at bottom) */}
      <Footer showpage={false} />
    </div>
  );
}
